import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { setSelectedSuggestionIndex } from '../actions/internalActions';
export default mutator(setSelectedSuggestionIndex, function (actionMessage) {
    getStore().selectedSuggestionIndex = actionMessage.selectedSuggestionIndex;
});
//# sourceMappingURL=setSelectedSuggestionIndexMutator.js.map